/** @prettier */
import React from "react";
import { toDataUri } from "../../util/imageUtils";

export type ImageProps = {
    name: string;
    image: string;
};
const Image = ({ name, image }: ImageProps) => (
    <img
        className="tr-question-image"
        src={toDataUri(image, name)}
        alt="Figure"
    />
);
export default Image;
